
<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>
					حذف حساب کاربری
					<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style mb-3">
				<div class="content">
					<p class="text-justify mb-0">
						شما در حال انجام عملیات
						<b class="text-danger">حذف حساب کاربری</b>
						هستید. لطفاً توجه داشته باشید که این اقدام
						<b class="text-danger">غیرقابل بازگشت</b>
						است و تمام اطلاعات مرتبط با حساب کاربری برای همیشه حذف خواهند شد.
						پس از حذف،
						<b class="text-danger">امکان بازیابی حساب وجود ندارد.</b>
					</p>
					<p class="text-justify mb-0 font-weight-bolder text-danger">
						اشتراک پرداخت شده قابل بازگشت و انتقال به کاربر دیگر نمی باشد.
					</p>
				</div>
			</div>

			<div class="userList-box-DeleteUserList">
				<div class="card card-style mb-2" v-for="user in taskOnlineItem.usersList" :key="user.id" :class="{ 'bg-fade-gray1-dark': user.selected === false }">
					<div class="list-group list-custom-small list-icon-0">
						<div class="list-group-div p-3" :class="{ 'text-muted': user.selected === false }">
							<div class="border-b pb-2 ">
								<div class="d-flex">
									<img v-if="user.adminOrUser === true && user.userImg!=null && user.userImg!=''" :src="user.userImg" alt="userProfileImg" width="40" height="40" class="rounded-circle img-object-fit" />
									<i class="fa fa-user-circle color-magenta2-dark font-45" v-if="user.adminOrUser === true && (user.userImg==null || user.userImg=='')"></i>
									<img v-if="user.adminOrUser === false && user.userImg!=null && user.userImg!=''" :src="user.userImg" alt="userProfileImg" width="40" height="40" class="rounded-circle img-object-fit" />
									<i class="fa fa-user-circle color-yellow1-dark font-45" v-if="user.adminOrUser === false  && (user.userImg==null || user.userImg=='')"></i>
									<div v-if="user.registByEmail==true" class="text-overflow-ellipsis w-100 line-height-m mr-3">
										<div class="text-overflow-ellipsis">
											{{ user.userTitle }}
										</div>
										<div class="text-overflow-ellipsis ltr">
											{{ user.emailAddress }}
										</div>
									</div>
									<div v-else class="w-100 line-height-m mr-3">
										<div class="text-overflow-ellipsis">
											{{ user.seq }} - {{ user.userTitle }}
										</div>
										<div class="text-overflow-ellipsis">
											{{ user.phoneNumber }}
										</div>
									</div>

								</div>
							</div>
							<div class="py-2 border-b mb-3" v-if="user.expireDate != null && user.expireDate != ''">
								<div class="">
									تاریخ انقضای فعلی:
									<span class="d-inline-block ltr text-left mr-2">{{user.expireDate}}</span>
									<span v-if="user.adminOrUser === true" class="badge bg-magenta2-light position-static mt-0 float-left mt-1">ادمین</span>

								</div>
							</div>
							<div class="DeleteUserList-btnBox">
								<button class="btn btn-border btn-xxs btn-full rounded-sm font-900 w-100 border-red2-dark color-red2-dark bg-white" @click="ShowUserInfoForDelete(user.id)">
									<i class="fa fa-trash-alt ml-2"></i>
									حذف حساب کاربری
								</button>
							</div>

						</div>

					</div>
				</div>
			</div>
			<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
				<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
					<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
				</div>
			</transition>
		</div>
		<Help-Menu title="حذف حساب کاربری" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
		<Help-Menu title="حذف حساب کاربری" keyEn="deleteUser" v-if="isKarnegasht==true"></Help-Menu>
	</div>
	<div class="modal-mask" v-if="showDeleteUserModal">
		<div class="modal-wrapper modal-lg">
			<div class="modal-container">
				<div class="modal-body m-0">
					<slot name="body">
						<div class="text-center mb-3">
							<i class="fa fa-exclamation-triangle text-warning fa-3x pt-3 icon-size"></i>
						</div>
						<p class="text-justify mb-0">
							شما در حال انجام عملیات
							<b class="text-danger">حذف حساب کاربری</b>
							هستید. لطفاً توجه داشته باشید که این اقدام
							<b class="text-danger">غیرقابل بازگشت</b>
							است و تمام اطلاعات مرتبط با حساب کاربری برای همیشه حذف خواهند شد.
						</p>
						<p class="text-justify mb-0">
							پس از حذف، امکان بازیابی حساب وجود ندارد.
						</p>
						<p class="text-justify mb-0 font-weight-bolder text-danger">
							اشتراک پرداخت شده قابل بازگشت و انتقال به کاربر دیگر نمی باشد.
						</p>
						<div class="divider my-2"></div>
						<div class="d-flex">
							<img v-if="userItem.adminOrUser === true && userItem.userImg!=null && userItem.userImg!=''" :src="userItem.userImg" alt="userProfileImg" width="40" height="40" class="rounded-circle ml-2 img-object-fit" />
							<i class="fa fa-user-circle color-magenta2-dark font-45 ml-2" v-if="userItem.adminOrUser === true && (userItem.userImg==null || userItem.userImg=='')"></i>
							<img v-if="userItem.adminOrUser === false && userItem.userImg!=null && userItem.userImg!=''" :src="userItem.userImg" alt="userProfileImg" width="40" height="40" class="rounded-circle ml-2 img-object-fit" />
							<i class="fa fa-user-circle color-yellow1-dark font-45 ml-2" v-if="userItem.adminOrUser === false  && (userItem.userImg==null || userItem.userImg=='')"></i>

							<div class="text-overflow-ellipsis w-100 line-height-m">
								<div class="text-overflow-ellipsis">
									{{ userItem.userTitle }}
								</div>
								<div class="text-overflow-ellipsis">
									{{ userItem.phoneNumber }}
								</div>
								<div class="text-overflow-ellipsis ltr">
									{{ userItem.emailAddress }}
								</div>
							</div>
						</div>
						<div class="my-2 text-left">
							<span v-if="userItem.registByEmail==true" class="badge bg-magenta2-light position-static mt-0">ثبت نام با ایمیل</span>
							<span v-else class="badge bg-magenta2-light position-static mt-0">ثبت نام با شماره تلفن همراه</span>
						</div>
						<div class="my-2">
							تاریخ انقضای فعلی:
							<span class="d-inline-block ltr text-left mr-2">{{userItem.expireDate}}</span>
							<span v-if="userItem.adminOrUser === true" class="badge bg-magenta2-light position-static mt-0 float-left mt-1">ادمین</span>
						</div>
						<div class="col-12">
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-green2-light font-900 w-100" @click="ShowAutdenticationCode()">
								<i class="fa fa-check ml-2"></i>
								کد احراز هویت دارم
							</button>
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-warning text-white font-900 w-100" @click="ShowDonotHaveAutdenticationCode()">
								<i class="fa fa-envelope ml-2"></i>
								کد احراز هویت ندارم
							</button>
						</div>
						<div class="mt-3 d-none" id="haveAutdenticationCode">
							<p class="mb-2">کد احراز هویت را وارد کنید:</p>
							<input class="form-control" type="text" v-model="verifyCode" maxlengtd="200">
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-red1-light font-900 w-100" @click="DeleteUserByAutdenticationCode()">
								<i class="fa fa-trash ml-2"></i>
								حذف حساب کاربری
							</button>
						</div>
						<div class="mt-3 d-none" id="donotHaveAutdenticationCode">
							<div class="display-flex justify-content-between">
								<p class="mb-2">دلیل حذف حساب کاربری را وارد کنید:</p>
								<textarea class="form-control" rows="4" v-model="reason" maxlengtd="200"></textarea>

								<button class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR"
										@pointerup="stopR">
									<span :class="btnRecord">
										<span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
									</span>
									<img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
								</button>

								<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-highlight font-900 w-100" @click="GetAutdenticationCode()">
									<i class="fa fa-envelope ml-2"></i>
									دریافت کد احراز هویت
								</button>
							</div>
							<p class="text-justify mb-0 mt-3">
								<i class="fa fa-question-circle text-danger Flip-h ml-2"></i>
								پس از دریافت کد احراز هویت، گزینه
								<b>کد احراز هویت دارم</b>
								را انتخاب و کد
								دریافت شده را وارد و روی دکمه حذف حساب کاربری کلیک کنید.
							</p>
							<p class="text-justify mb-0 mt-3">
								<i class="fa fa-question-circle text-danger Flip-h ml-2"></i>
								اگر کاربر قبلا پرداخت اشتراک نداشته است مستقیم  حذف خواهد شد بدون دریافت کد احراز هویت
							</p>
						</div>
					</slot>
				</div>
				<div class="modal-footer py-1 px-2">
					<slot name="footer">
						<button type="button" class="btn btn-danger btn-xxs" @click="closeModalUser"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
					</slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import 'vue-select/dist/vue-select.css';
	import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition   
	export default {
        components: {
            "Help-Menu": HelpMenu
        },
		data() {
			return {
				showDeleteUserModal: false,
				pageLoading: false,
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",

				reason: "",
				verifyCode: "",
				userCode: "",
				selectedId: 0,
				userItem: null,
				taskOnlineItem: {
					companyTitle: "",
					adminCode: "",
					usersList: [],
				}
			}
		},
		created() {
			this.GetUserItems();
		},
        mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.reason == null || this.reason == "null")
                        this.reason = "";
                    if (rest != null && rest != '')
                        this.reason = this.reason + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
			}
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
		methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },

			ShowUserInfoForDelete(userId) {
				var item = this.taskOnlineItem.usersList
					.filter((x) => x.id == userId);
				if (item != null) {
					this.userItem = item[0];
					this.selectedId = userId;
					this.reason = "";
					this.verifyCode = "";
					this.showDeleteUserModal = true;
				}
			},
			closeModalUser() {
				this.userItem = null;
				this.selectedId = 0;
				this.reason = "";
				this.verifyCode = "";
				this.showDeleteUserModal = false;
			},
			ShowDonotHaveAutdenticationCode() {
				document.getElementById("donotHaveAutdenticationCode").classList.remove("d-none");
				document.getElementById("haveAutdenticationCode").classList.add("d-none");
			},
			ShowAutdenticationCode() {
				document.getElementById("haveAutdenticationCode").classList.remove("d-none");
				document.getElementById("donotHaveAutdenticationCode").classList.add("d-none");
			},
			DeleteUserByAutdenticationCode() {
				if (this.selectedId == null || this.selectedId == 0 || this.verifyCode == null || this.verifyCode == '') {
					this.showErrorMessage("اطلاعات ارسالی معتبر نیست");
					return;
				}
				var obj = {
					registByEmail: false,
					userId: this.selectedId,
					verifyCode: this.verifyCode
				};
				this.pageLoading = true;
				this.$http.post("TaskOnline/DeleteUserByAuthenticationCode", obj)
					.then(data => {
						this.pageLoading = false;
						var res = data.data;
						if (res.isSuccess) {
							this.showSuccessMessage("حساب کاربری حذف شد.");
							if (this.userItem.adminOrUser) {
								this.$store.dispatch("SignOutUser");
							} else {
								this.closeModalUser();
								this.GetUserItems();
							}
						} else {
							this.showErrorMessage(res.message);
						}
					});

			},
			GetAutdenticationCode() {
				if (this.reason.lengtd < 10) {
					this.showErrorMessage("دلیل حذف باید بیشتر از 10 کاراکتر باشد.");
					return;
				}
				if (this.reason.lengtd > 200) {
					this.showErrorMessage("دلیل حذف نمیتواند بیشتر از 200 کاراکتر باشد.");
					return;
				}
				if (this.selectedId == null || this.selectedId == 0) {
					this.showErrorMessage("اطلاعات ارسالی معتبر نیست");
					return;
				}
				let obj = {
					registByEmail: false,
					userId: this.selectedId,
					reason: this.reason
				};
				this.pageLoading = true;
				this.$http.post("TaskOnline/GetAuthenticationCode", obj)
					.then(data => {
						this.pageLoading = false;
						var res2 = data.data;
						if (res2.isSuccess) {
                            if (res2.message == "2") {
								this.closeModalUser();
								this.showSuccessMessage("حساب کاربری حذف شد.");
								this.GetUserItems();
							} else {
								this.showSuccessMessage("کد احراز هویت برای کاربر مورد نظر ارسال شد");
								this.ShowAutdenticationCode();
							}

						} else {
							this.showErrorMessage(res2.message);
						}
					});
			},
			GetUserItems() {
				this.pageLoading = true;
				this.reason = "";
				this.verifyCode = "";
				this.$http.get("TaskOnline/GetByUserCodeForAdmin").then((data) => {
					this.pageLoading = false;
					this.taskOnlineItem = data.data;
				});
			}
		}
	}
</script>
